<div
  class="state-row w-100"
  [ngClass]="{
    loading: computedRecord.computedState === 'loading',
    warning: hasWarning,
    conflict: hasAnyConflict,
    inverted: zone === 'right',
    'has-action': showAction
  }"
>
  <div class="taguid">
    <div class="a">{{ computedRecord.record.tag_uid }}</div>
    <div class="warnings">
      <mat-icon
        class="fs"
        *ngIf="
          !!computedRecord.computedStatusMessage ||
          !!computedRecord.computedPairingStatusMessage
        "
        >warning</mat-icon
      >
      <span class="wtext" *ngIf="!!computedRecord.computedStatusMessage">{{
        computedRecord.computedStatusMessage
      }}</span>
      <span
        class="wtext"
        *ngIf="!!computedRecord.computedPairingStatusMessage"
        >{{ computedRecord.computedPairingStatusMessage }}</span
      >
    </div>
  </div>
  <ng-container *ngIf="showAction">
    <button
      *ngIf="computedRecord.computedState !== 'loading'; else loading"
      class="action btn-default"
      (click)="onAction($event)"
    >
      <mat-icon class="fs">{{ icon }}</mat-icon>
    </button>
    <ng-template #loading>
      <div class="action d-flex align-items-center justify-content-center">
        <mat-spinner [diameter]="20" color="primary"></mat-spinner>
      </div>
    </ng-template>
  </ng-container>
</div>
